import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');
import Swiper, { Mousewheel, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function() {

    window.facts = function() {
        
        const el = document.getElementById('facts'),
              item = el.querySelectorAll("[data-vid]"),
              firstVideo = el.getElementsByClassName('is-active')[0].dataset.vid,
              captions = el.getElementsByClassName('js-captions')[0],
              caption = captions.getElementsByTagName('li');
        const factsNav = document.getElementsByClassName('js-factsNavSlider')[0];
        
        let player, swiper; 
        
	    swiper = new Swiper(factsNav, {
    	    direction: "vertical",
            freeMode: true,
            //loop: true,
            //loopedSlides: 0,
            mousewheel: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
        });

        window.videolist = {
            def: function() {
                player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: firstVideo,
                            provider: 'vimeo',
                        },
                    ],
                };  
                
/*
                setTimeout(function() {
                    player.muted = false;
                    player.volume = 1;
                    console.log(player.muted);
                }, 1000);
*/
            },
            load: function(e) {
                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;

                for (let i = 0; i < item.length; i++) {
                    console.log(item[i].classList);
                    item[i].classList.remove('is-active');
                    
                    if ( (item[i].dataset.vid === e.currentTarget.dataset.vid) && (!item[i].classList.contains('swiper-slide-duplicate'))) {                        
                        item[i].classList.add('is-active');
                        
                    } else {
                        item[i].classList.remove('is-active');
                    }
                }
                
                console.log();
                
                swiper.slideTo(e.currentTarget.dataset.id);
                
                // captions for mobile
                for (let i = 0; i < caption.length; i++) {
                    caption[i].classList.remove('is-active');
                }
                
                if (window.innerWidth <= 768) {
                    caption[e.currentTarget.innerHTML - 1].classList.add('is-active');
                }
                
                videolist.play(e.currentTarget.dataset.vid);
            },
            play: function(id) {
                
                player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: id,
                            provider: 'vimeo',
                        },
                    ],
                };
                
                setTimeout(function() {
                    player.muted = false;
                    player.volume = 1;
                    player.play();
                    
                    const videoWrapper = el.getElementsByClassName("plyr__video-wrapper")[0];
                    videoWrapper.addEventListener("click", event => {
                        player.togglePlay();
                        event.stopPropagation(); // Necessary or the video will toggle twice => no playback
                    });
    
                    player.toggleControls(false);
                }, 1000);
            },
            player_desktop: function() {
                player = new Plyr('#factsPlayer', {
                    ratio: '16:9',
                    controls: ['play-large'],
                    muted: false,
                    volume: 1,
                    vimeo: { 
                        sidedock: 0, 
                        controls: 0,
                        muted: 0
                    } 
                });
                player.muted = false;
                
                setTimeout(function() {
                    player.muted = false;
                    player.volume = 1;
                }, 1000);
                
                videolist.def();
                
                
                const videoWrapper = el.getElementsByClassName("plyr__video-wrapper")[0];
                videoWrapper.addEventListener("click", event => {
                    player.togglePlay();
                    event.stopPropagation(); // Necessary or the video will toggle twice => no playback
                });

                player.toggleControls(false);
            }
        }

        for (let i = 0; i < item.length; i++) {
            item[i].addEventListener('click', videolist.load);
        }
        
       
        
/*
*/
        
        
        //factsNav ? factsNavCarousel() : false;
        
        setTimeout(videolist.player_desktop(), 2000)
    };    

}, false)
